import 'react';
import '../types/props.js';
import 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import Pane from '../Pane/index.js';
import '../Text/styled.js';
import Text from '../Text/index.js';
import 'reakit/Label';
import Field from 'reakit/Field';
import '../Label/styled.js';
import _Label from '../Label/index.js';
var Label = styled(_Label).withConfig({
  displayName: "styled__Label",
  componentId: "ixmo9v-0"
})(["margin-bottom:0 !important;&{", ";}"], theme('fannypack.FieldWrapper.label'));
var DescriptionText = styled(Text).withConfig({
  displayName: "styled__DescriptionText",
  componentId: "ixmo9v-1"
})(["display:block;font-size:0.8rem;&{", ";}"], theme('fannypack.FieldWrapper.description'));
var HintText = styled(Text).withConfig({
  displayName: "styled__HintText",
  componentId: "ixmo9v-2"
})(["display:block;font-size:0.8rem;margin-top:", "rem;&{", ";}"], space(1), theme('fannypack.FieldWrapper.hint'));
var OptionalText = styled(Text).withConfig({
  displayName: "styled__OptionalText",
  componentId: "ixmo9v-3"
})(["font-size:0.8rem;color:", ";margin-left:", "rem;line-height:1;&{", ";}"], palette('text100'), space(2), theme('fannypack.FieldWrapper.optional'));
var RequiredText = styled(Text).withConfig({
  displayName: "styled__RequiredText",
  componentId: "ixmo9v-4"
})(["color:", ";margin-left:", "rem;font-weight:", ";font-size:", "rem;&{", ";}"], palette('danger'), space(1), theme('fannypack.fontWeights.semibold'), theme('fannypack.fontSizes.150'), theme('fannypack.FieldWrapper.required'));
var TooltipButton = styled(Button).withConfig({
  displayName: "styled__TooltipButton",
  componentId: "ixmo9v-5"
})(["margin-left:", "rem;min-height:unset;height:14px;padding:0.1em 0.5em;&{", ";}"], space(1), theme('fannypack.FieldWrapper.TooltipButton.base'));
var TooltipPopover = styled(Pane).withConfig({
  displayName: "styled__TooltipPopover",
  componentId: "ixmo9v-6"
})(["position:absolute;padding:", "rem;margin-top:", "rem;width:max-content;max-width:400px;z-index:999999;&{", ";}"], space(1, 'major'), space(1, 'major'), theme('fannypack.FieldWrapper.TooltipPopover.base'));
var ValidationText = styled(Text).withConfig({
  displayName: "styled__ValidationText",
  componentId: "ixmo9v-7"
})(["display:block;font-size:0.8rem;margin-top:", "rem;&{", ";}"], space(1), theme('fannypack.FieldWrapper.validation'));
var FieldWrapper = styled(Field).withConfig({
  displayName: "styled__FieldWrapper",
  componentId: "ixmo9v-8"
})(["&{", ";}"], theme('fannypack.FieldWrapper.base'));
export default FieldWrapper;
export { DescriptionText, FieldWrapper, HintText, Label, OptionalText, RequiredText, TooltipButton, TooltipPopover, ValidationText };